import React from 'react';
import { Table, Tag, Row, Result, Card, Space } from 'antd';
import moment from 'moment';

import { table } from 'src/utils';

import { operatorColumns, operationColumns, efficiencyColumns, operationGroupColumns } from './table.utils';
import { IProps } from './table.type';

const asColor = (color?: string) => {
  const normalized = (color || '').toString().trim();
  if (!normalized) return 'default';
  return normalized;
};

const TableComponent: React.FC<IProps> = ({ report }) => {
  const header = () => (
    <span>
      <Row gutter={16} justify="space-between" align="middle">
        <div className="px-2">
          <b>{report?.cell?.name}</b> | {moment().format('DD/MM/YYYY')}
        </div>

        {report?.reportType === 'operation' && (
          <div className="px-2">
            <Tag color="green" className="m-0">
              Meta: <b>{report?.cell?.target}</b>
            </Tag>
          </div>
        )}

        {report?.reportType === 'efficiency' && (
          <div className="px-2">
            <Tag color="green" className="m-0">
              Eficiência Média: <b>{report?.averageEfficiency?.toFixed(2)}%</b>
            </Tag>
          </div>
        )}

        {report?.reportType === 'operationGroup' && (
          <div className="px-2">
            <Space size={8}>
              <Tag color="cyan" className="m-0">
                Meta por Hora: <b>{Number(report?.cell?.target || 0)}</b>
              </Tag>
              <Tag color="gold" className="m-0">
                Total de Operações: <b>{Number(report?.totalCellOperationsQuantity || 0)}</b>
              </Tag>
              <Tag color="blue" className="m-0">
                Meta: <b>{Number(report?.cellTargetAccumulated || 0)}</b>
              </Tag>
              <Tag color={asColor(report?.color) || 'green'} className="m-0">
                Produzido: <b>{Number(report?.totalProduction || 0)}</b>
              </Tag>
            </Space>
          </div>
        )}

        <div style={{ fontSize: 12 }}>
          Modo de exibição:{' '}
          <Tag style={{ fontSize: 12 }}>
            <b>
              {report?.reportType === 'operator'
                ? 'Operador'
                : report?.reportType === 'operation'
                ? 'Operação'
                : report?.reportType === 'operationGroup'
                ? 'Grupo de operações'
                : 'Eficiência'}
            </b>
          </Tag>
        </div>
      </Row>
    </span>
  );

  const footer = () => (
    <span>
      <Row gutter={16} justify="space-between" align="middle">
        <div className="px-2">
          <span>
            Última atualização às {moment(report?.updateAt).format('HH:mm')}
          </span>
        </div>
      </Row>
    </span>
  );

  return (
    <div>
      {report && report?.data.length ? (
        <Table
          {...table}
          title={header}
          footer={footer}
          columns={
            report.reportType === 'operation'
              ? operationColumns(Number(report?.cell?.target) || 0)
              : report.reportType === 'efficiency'
              ? efficiencyColumns
              : report.reportType === 'operationGroup'
              ? operationGroupColumns
              : operatorColumns
          }
          dataSource={report?.data || []}
          scroll={{ x: 1000, y: 'auto' }}
          pagination={false}
          className="mb-3"
        />
      ) : (
        <Card>
          <Result
            status="warning"
            title="Ocorreu um erro ao buscar as informações, tente novamente mais tarde."
          />
        </Card>
      )}
    </div>
  );
};

export default TableComponent;
